<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>{{ $t('StationDetailAddMetadata.addTitleMsg') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <MetadataForm ref="form" :station="station" :metadata="metadata" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" @click="submit()">
          <v-icon class="mr-1">done</v-icon>
          {{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" outline @click="close()">{{ $t('Button.Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import MetadataForm from './MetadataForm'

  const stationmetadata = createNamespacedHelpers('stationmetadata')
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      MetadataForm,
    },
    props: {
      station: Object,
      metadata: Array,
    },
    data() {
      return {
        dialog: false,
      }
    },
    methods: {
      ...stationmetadata.mapActions(['upsertMetadata']),
      ...app.mapActions(['setSnackbar']),
      async show() {
        this.dialog = true

        await this.$nextTick()
        this.$refs.form.initialize()
      },
      close() {
        this.dialog = false
      },
      async submit() {
        if (!this.$refs.form.validate()) return
        let payload = this.$refs.form.payload

        try {
          await this.upsertMetadata(payload)

          this.dialog = false
          this.setSnackbar({
            text: this.$t('StationDetailAddMetadata.addSuccessMsg'),
            color: 'success',
            icon: 'done',
          })

          this.$emit('refresh')
        } catch (error) {
          this.setSnackbar({
            text: error,
            color: 'error',
            icon: 'error',
          })
        }
      },
    },
  }
</script>